import React from "react";
import { createRoot } from "react-dom/client";
import ParticipantConfirmDialog from "./ParticipantConfirmDialog";
import { TranslateContext } from "../../../widgets/MyDataHelps/TranslateContext";

export interface ParticipantConfirmOptions {
    okTextKey?: string;
    cancelTextKey?: string;
    translate?: (key: string, values?: Record<string, unknown>) => Promise<string>;
}

/**
 * Drop-in async replacement for window.confirm().
 * Uses a React modal instead of the native browser dialog,
 * which is silently suppressed in WKWebView (iOS Chrome).
 */
const fallbackTranslate = (key: string) => Promise.resolve(key);

export function participantConfirm(message: string, options: ParticipantConfirmOptions = {}): Promise<boolean> {
    const { okTextKey, cancelTextKey, translate = fallbackTranslate } = options;
    return new Promise((resolve) => {
        const container = document.body.appendChild(document.createElement('div'));
        const root = createRoot(container);

        const cleanup = (result: boolean) => {
            root.unmount();
            container.remove();
            resolve(result);
        };
        const dialog = React.createElement(ParticipantConfirmDialog, {
            message,
            okTextKey,
            cancelTextKey,
            onConfirm: () => cleanup(true),
            onCancel: () => cleanup(false),
        });

        root.render(
            React.createElement(TranslateContext.Provider, { value: translate }, dialog)
        );
    });
}
